import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useState } from "react";
import { ContentPartFilter } from "../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../components/page-header";
import { EntFarmOwner } from "../../../models/farmOwners";
import { EntFarmOwnerFilter } from "../../../models/filters/farmOwnersFilter";
import { AddFarmOwnerModal } from "./AddFarmOwnerModal";
import { FilterFarmOwner } from "./FilterFarmOwner";
import { useFarmOwners } from "./useFarmOwners";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { useLazyGetFarmOwnersListQuery } from "../../../redux/api/farmOwners/farmOwnersApi";
enum FormField {
  fullName,
}


export const FarmOwners = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedFarmOwner, setSelectedFarmOwner] = useState<EntFarmOwner>(new EntFarmOwner());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [form] = useForm();
  const {t} = useTranslation()

  const [getArchiveFolders] = useLazyGetFarmOwnersListQuery();
  const {
    filter,
    fetching,
    data,
    totalItems,
    setData,
    setFetching,
    setFilter,
    scrollHandler,
    setCurrentPage
  } = useGetDataOnScroll<EntFarmOwner, EntFarmOwnerFilter>({
    initialFilter: new EntFarmOwnerFilter(),
    query: getArchiveFolders
  });

  const { onAddFarmOwner, onEditFarmOwner, onDeleteFarmOwner } = useFarmOwners(modal, () => { searchHandleClick(); })
  const [height, setHeight] = useState<number>(0);
  const openAddModal = (item: EntFarmOwner) => {
    setSelectedFarmOwner(item);
    setShowModal(true);
  }
  const setEntityFromFields = (): EntFarmOwnerFilter => {
    let filt: EntFarmOwnerFilter = _.clone(filter);
    filt.fullName = form.getFieldValue(FormField.fullName) ?? null;
    return filt;
  }
  const clearFields = () => {
    form.setFields([
      { name: FormField.fullName, value: null },
    ]);
  }
  const searchHandleClick = () => {
    setFilter(setEntityFromFields());
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }
  const table = (
    <div style={{ maxHeight: `${height}px`, overflow: 'auto' }} onScroll={scrollHandler}>
      <table>
        <thead>
          <tr>
            <th style={{ width: "40px" }}>#</th>
            <th>{ t('user.name_employee') }</th>
            <th>{ t('user.surname') }</th>
            <th>{ t('user.last_name') }</th>
            <th>{ t('user.contacts') }</th>
            <th style={{ width: "120px" }}></th>
          </tr>
        </thead>
        <tbody>
          {fetching ?
            <tr>
              <th colSpan={5}>
                <Spin spinning={fetching} style={{
                  width: '100%',
                  height: '180px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }} />
              </th>
            </tr>
            : <></>}
          {data.map((item, index) => (
            <tr key={item.id}>
              <td>{++index}</td>
              <td>{item?.name}</td>
              <td>{item?.secondName}</td>
              <td>{item?.patronymic}</td>
              <td>{item?.contacts}</td>
              <td>
                <Flex gap="small">
                  <Tooltip title={ t('general.edit') }>
                    <Button className='btn_edit' onClick={() => {openAddModal(item) }} type="primary" shape="circle" icon={<EditOutlined />} />
                  </Tooltip>
                  <Tooltip title={ t('general.delete') }>
                    <Button className='btn_edit' danger onClick={() => {onDeleteFarmOwner(item)}} type="primary" shape="circle" icon={<DeleteOutlined />} />
                  </Tooltip>
                </Flex>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
  return (
    <>
      <PageHeader
        title={ t('titles.register_of_farmowners') }
        additionalInfo={
          <Typography.Text style={{ marginBottom: '0.5em', display: 'block' }} type="secondary">{ t('registers.register_of_farmowners.register_of_farmowners_desc') } {t('general.records_found')} {totalItems}</Typography.Text>
        } />
      <Button type="primary" icon={<PlusOutlined />} onClick={()=>{openAddModal(new EntFarmOwner)}}>
        { t('registers.register_of_farmowners.add_owner') }
      </Button>
      <ContentPartFilter
        filter={<FilterFarmOwner        onSearch={searchHandleClick}
        onReset={() => { clearFields(); searchHandleClick() }} formField={FormField} form={form} />}
        setHeight={setHeight}
        table={table}
 
      />
     <AddFarmOwnerModal
        farmOwner={selectedFarmOwner}
        show={showModal}
        onHide={() => {
          setShowModal(false)
        }}
        onSubmit={selectedFarmOwner.id !== 0 ? onEditFarmOwner : onAddFarmOwner} 
      />
      {contextHolder}
    </>
  )
}
